<template>
  <q-dialog v-model="operation" persistent>
    <q-card style="max-width: 600px; width: 100%">
      <q-form @submit="onSubmit" ref="myForm" class="flexbox">
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Company Name*</span>
              <q-select
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :options="companies"
                :rules="[val => !!val.id || 'Please select your company']"
                :option-label="company => company.name"
                :option-value="company => company.id"
                v-model="company"
                hide-bottom-space
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Location Name*</span>
              <q-select
                class="customTextColor"
                outlined
                color="grey-7"
                :disable="!company.id"
                label-color="grey-7"
                lazy-rules
                :options="locations"
                :rules="[val => !!val.id || 'Please select your location']"
                :option-label="location => location.name"
                :option-value="location => location.id"
                v-model="location"
                hide-bottom-space
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <div class="label-input">VIN NUMBER*</div>
              <q-input
                :disable="!location.id"
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :rules="[
                  val => (val !== null && val !== '' && val.length === 17) || 'Please type 17 chars VIN number.'
                ]"
                v-model="vin"
                hide-bottom-space
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-fingerprint" size="15px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Year*</span>
              <q-input
                type="number"
                class="customTextColor"
                outlined
                color="grey-7"
                @change="yearChangeHandler"
                label-color="grey-7"
                lazy-rules
                v-model="modelYear"
                :rules="[
                  val =>
                    val === null ||
                    val === '' ||
                    (val > 2000 && val <= new Date().getFullYear() + 2) ||
                    `Vehicle register date min bigger than 2000 and less than ${new Date().getFullYear() + 2}`
                ]"
              ></q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <div class="label-input">UNIT NUMBER*</div>
              <q-input
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :rules="[val => (val !== null && val !== '') || 'Please type UNIT number.']"
                v-model="unit"
                hide-bottom-space
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-cogs" size="15px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Brand</span>
              <q-select
                :disable="!modelYear"
                class="customTextColor"
                outlined
                @input="brandChangeHandler"
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :options="brands"
                v-model="brand"
                hide-bottom-space
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-car" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Model</span>
              <q-select
                :disable="!brand"
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                @input="modelChangeHandler"
                lazy-rules
                :options="models"
                v-model="model"
                ><template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template></q-select
              >
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Model Detail</span>
              <q-select
                :disable="!model"
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :options="modelDetails"
                v-model="modelDetail"
                ><template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template></q-select
              >
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6" style="position: relative">
              <span class="label-input">Class</span>
              <q-select
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                :options="classes"
                v-model="selectedClass"
                ><template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template></q-select>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Color</span>
              <q-input
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                v-model="color"
                hide-bottom-space
              ></q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Custom Tag</span>
              <q-select
                outlined
                class="customTextColor"
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                multiple
                :options="tags"
                :option-label="tag => tag.name"
                :option-value="tag => tag.id"
                v-model="localTags"
                hide-bottom-space
                ><template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template></q-select
              >
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Condition</span>
              <q-select
                outlined
                class="customTextColor"
                color="grey-7"
                label-color="grey-7"
                :options="conditions"
                :option-label="cond => cond.name"
                :option-value="cond => cond.val"
                v-model="condition"
                hide-bottom-space
                ><template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template></q-select
              >
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Mileage*</span>
              <q-input
                :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Mileage value.']"
                type="number"
                class="customTextColor"
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                v-model="mileage"
              ></q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">In Service Date*</span>
              <q-input
                dense
                class="customTextColor"
                outlined
                color="grey-7"
                hide-bottom-space
                label-color="grey-7"
                v-model="in_service_date"
                mask="date"
                :rules="['date' || 'Invalid type In Service Date']"
              >
                <template v-slot:append>
                  <q-icon name="fas fa-calendar" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy1" transition-show="scale" transition-hide="scale">
                      <q-date v-model="in_service_date">
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Close" color="primary" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
              <span class="label-input">Status</span>
              <q-select
                outlined
                class="customTextColor"
                color="grey-7"
                label-color="grey-7"
                :options="statuses()"
                :option-label="status => status.label"
                :option-value="status => status.value"
                v-model="status"
                hide-bottom-space>
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-12">
              <div class="mt-5 flex-end q-gutter-xs">
                <q-btn color="grey-7" @click="extraCancel()">CANCEL</q-btn>
                <q-btn :loading="loading" label="Save" type="submit" color="positive">
                  <template v-slot:loading>
                    <q-spinner-facebook />
                  </template>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
import SelectList from '../components/base/SelectList.vue'
import {statuses} from "@/enums";
export default {
  components: {
    SelectList
  },
  data() {
    return {
      innerLoading: false,
      loading: false,
      company: {},
      classes: [],
      selectedClass: null,
      manheimResult: false,
      in_service_date: null,
      vin: '',
      unit: '',
      brand: null,
      model: null,
      modelDetail: null,
      color: '',
      segment: '',
      conditions: [
        { name: 'Above', val: 'excellent' },
        { name: 'Average', val: 'good' },
        { name: 'Below', val: 'fair' }
      ],
      condition: { name: 'Good', val: 'good' },
      status: statuses[0],
      modelYear: '',
      openGroups: false,
      openClass: false,
      models: [],
      modelDetails: [],
      brands: [],
      mileage: '',
      group: '',
      location: {},
      localTags: [],
      result: false,
      locations: []
    }
  },
  methods: {
    statuses() {
      return statuses
    },
    async getCompanyVehicleClasses() {
        try {
            const response = await axios.get('/company-vehicle-classes', {
                params: {
                    company_id: this.company.id
                }
            });
            this.classes = response.data.data.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            });
        } catch (e) {
            console.log(e);
        }
    },
    selectGroup(group) {
      this.group = group
      this.openGroups = false
    },
    selectClass(cls) {
      this.segment = cls
      this.openClass = false
    },
    yearChangeHandler() {
      this.resetKeys(['brand', 'model', 'modelDetail'])
    },
    brandChangeHandler(e) {
      this.resetKeys(['model', 'modelDetail'])
      this.getModelViaVIN(this.modelYear, e)
    },
    modelChangeHandler(e) {
      this.resetKeys(['modelDetail'])
      this.getModelDetailViaVIN(this.modelYear, this.brand, e)
    },
    resetKeys(keys) {
      const self = this
      keys.forEach(key => {
        self[key] = null
      })
    },
    async getBrandViaVIN(year) {
      try {
        const { data } = await axios.get(`vehicle-brands-by-year/${year}`)
        this.brands = data.data
        this.brand && this.getModelViaVIN(year, this.brand)
      } catch (error) {}
    },
    async getModelViaVIN(year, brand) {
      try {
        const { data } = await axios.get(`vehicle-models-by-year/${year}/${brand}`)
        this.models = data.data
        this.model && this.getModelDetailViaVIN(year, brand, this.model)
      } catch (error) {}
    },
    async getModelDetailViaVIN(year, brand, model) {
      try {
        const { data } = await axios.get(`vehicle-model-details-by-year/${year}/${brand}/${model}`)
        this.modelDetails = data.data
      } catch (error) {}
    },
    async handleVin() {
      this.innerLoading = true
      try {
        const body = {
          vin: this.vin,
          region: this.location.region
        }
        const {
          data: { data }
        } = await axios.post('queries/manheim/provision', body)
        this.manheimResult = true
        this.brand = data.brand
        this.model = data.model
        this.modelDetail = data.model_detail
        this.modelYear = data.model_year
      } catch (error) {
        const errors = error.response?.data?.errors

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }

        if (error.response?.data?.code === 404) {
          message = error.response?.data?.message
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors)
        }

        const notFound = error.response?.data?.code === 500
        if (notFound) {
          this.manheimResult = false
          this.brand = ''
          this.model = ''
          this.modelDetail = ''
          this.modelYear = ''
        }
        this.$q.notify({
          message: notFound ? 'Can not find vehicles please contiune manual entrying' : message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
        this.result = false
      } finally {
        this.result = false
        this.innerLoading = false
      }
    },
    extraCancel() {
      this.resetter()
      this.operation = false
    },
    async getLocationByCompanyId(id) {
      if (!id) return true
      const params = { company_id: id }
      const { data } = await axios.get(`locations`, { params })
      this.locations = data.data || []
    },
    async getDetails(modelId) {
      const { data } = await axios.get('vehicle-model', {
        params: { model_id: modelId }
      })
      this.modelDetails = data.data
    },
    async getModels(brandId) {
      const { data } = await axios.get('vehicle-models', {
        params: { brand_id: brandId }
      })
      this.models = data.data
    },
    async onSubmit() {
      try {
        this.loading = true
        const { body } = await this.bodyHandler()
        const { data } = await axios.put('vehicles', body)
        this.condition = { name: 'Good', val: 'good' }
        this.operation = false
        this.$store.commit('vehicle/ADD_VEHICLE', data.data)
        this.$q.notify({
          message: 'Successfully added',
          timeout: 2500,
          progress: true,
          type: 'positive'
        })
        this.extraCancel()
      } catch (error) {
        const errors = error.response?.data?.errors || 'Something went wrong'

        let message = ''

        function errorHandler(obj) {
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const element = obj[key]
              if (Array.isArray(element)) {
                message = element[0]
              } else if (typeof element === 'object') {
                errorHandler(element)
              } else {
                message = element
              }
            }
          }
        }

        if (error.response?.data?.code === 400 || error.response?.data?.code === 404) {
          message = error.response?.data?.message
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors)
        }

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    },
    bodyHandler() {
      const body = {
        company: this.company.id,
        vin: this.vin,
        unit: this.unit,
        condition: this.condition.val,
        location: this.location.id,
        mileage: +this.mileage,
        in_service_date: this.in_service_date,
        status: this.status.value,
      }
      if (this.localTags.length > 0) body.tags = this.localTags.map(item => item.id)
      if (this.brand) body.brand_name = this.brand
      if (this.model) body.model_name = this.model
      if (this.modelDetail) body.model_detail_name = this.modelDetail
      if (this.selectedClass) body.company_class = this.selectedClass.value
      if (this.modelYear) body.model_year = +this.modelYear
      if (this.color) body.color = this.color
      if (this.in_service_date)
        body.in_service_date = this.in_service_date ? this.in_service_date.replaceAll('/', '-') : null
      return { body }
    },
    async getCompanies() {
      const { data } = await axios.get('companies')
      this.companies = data.data
    },
    resetter() {
      this.result = false
      this.loading = false
      this.company = ''
      this.vin = ''
      this.unit = ''
      this.brand = ''
      this.model = ''
      this.mileage = ''
      this.modelDetail = ''
      this.color = ''
      this.segment = ''
      this.modelYear = ''
      this.model = ''
      this.detail = ''
      this.group = ''
      this.in_service_date = null
      this.status = statuses[0]
    }
  },
  computed: {
    tags: {
      get() {
        return this.$store.state.tag.tags
      },
      set(val) {
        this.$store.commit('tag/SET_TAGS', val)
      }
    },
    groups() {
      return this.$store.state.vehicle.groups
    },
    operation: {
      get() {
        return this.$store.state.vehicle.operation
      },
      set(val) {
        this.$store.commit('vehicle/SET_VEHICLE_OPERATION', val)
      }
    },
    companies: {
      get() {
        return this.$store.state.company.companies
      },
      set(val) {
        this.$store.commit('company/SET_USER_COMPANIES', val)
      }
    }
  },
  watch: {
    modelYear: {
      handler(n) {
        n && n >= 2000 && n <= new Date().getFullYear() && this.getBrandViaVIN(n)
      },
      deep: true,
      immediate: true
    },
    company: {
      deep: true,
      handler(n, o) {
        this.location = {}
        this.getLocationByCompanyId(n.id)
        this.getCompanyVehicleClasses()
      }
    },
    vin: {
      immediate: true,
      handler(n, o) {
        if (n !== o && n.length === 17) {
          this.handleVin()
        }
      }
    }
  }
}
</script>
